import { api } from './api';

export interface DamageAssessmentReportListItemDto {
  id: number;
  reportNo: string;
  createdAt: string;
}

export interface DamageAssessmentReportItemDto {
  id?: number;
  zoneNumber: number;
  zoneName?: string;
  damageType: string;
}

export interface DamageAssessmentReportPhotoDto {
  id: number;
  fileName: string;
  url: string;
}

export interface DamageAssessmentReportDto {
  id: number;
  vehicleId: number;
  vehiclePlate: string;
  customerId: number;
  customerName: string;
  serviceOrderId?: number | null;
  serviceOrderNo?: string | null;
  reportNo: string;
  createdAt: string;
  notes?: string | null;
  items: DamageAssessmentReportItemDto[];
  photos: DamageAssessmentReportPhotoDto[];
}

export interface CreateDamageAssessmentReportRequest {
  vehicleId: number;
  customerId: number;
  serviceOrderId?: number | null;
  notes?: string | null;
}

export interface UpdateDamageAssessmentReportRequest {
  notes?: string | null;
  items: DamageAssessmentReportItemDto[];
}

const DAMAGE_TYPES = ['Boyalı', 'Değişen', 'Göçük', 'Ufak Kusur', 'Büyük Kusur'] as const;
export const DAMAGE_TYPE_OPTIONS = DAMAGE_TYPES;

export async function fetchReportsByVehicle(vehicleId: number): Promise<DamageAssessmentReportListItemDto[]> {
  const { data } = await api.get<DamageAssessmentReportListItemDto[]>(`/damage-assessment-reports/by-vehicle/${vehicleId}`);
  return data;
}

export async function fetchDamageReport(id: number): Promise<DamageAssessmentReportDto> {
  const { data } = await api.get<DamageAssessmentReportDto>(`/damage-assessment-reports/${id}`);
  return data;
}

export async function createDamageReport(req: CreateDamageAssessmentReportRequest): Promise<DamageAssessmentReportDto> {
  const { data } = await api.post<DamageAssessmentReportDto>('/damage-assessment-reports', req);
  return data;
}

export async function updateDamageReport(id: number, req: UpdateDamageAssessmentReportRequest): Promise<DamageAssessmentReportDto> {
  const { data } = await api.put<DamageAssessmentReportDto>(`/damage-assessment-reports/${id}`, req);
  return data;
}

export async function uploadDamageReportPhoto(reportId: number, file: File): Promise<DamageAssessmentReportPhotoDto> {
  const form = new FormData();
  form.append('file', file);
  const { data } = await api.post<DamageAssessmentReportPhotoDto>(`/damage-assessment-reports/${reportId}/photos`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function deleteDamageReportPhoto(reportId: number, photoId: number): Promise<void> {
  await api.delete(`/damage-assessment-reports/${reportId}/photos/${photoId}`);
}

export async function deleteDamageReport(id: number): Promise<void> {
  await api.delete(`/damage-assessment-reports/${id}`);
}
